import { DelimitedTextFormatter } from 'field-kit';
import { USDate } from '@banking/api/utils/date-format';
export default class USDateFormatter extends DelimitedTextFormatter {
  constructor() {
    super('/');
    this.maximumLength = 10;
  }
  hasDelimiterAtIndex(index) {
    return index === 2 || index === 5;
  }

  // TODO(steckel): move most of this into parse and format.
  isChangeValid(change, error) {
    if (change.inserted.text === '/') {
      let text;
      switch (change.inserted.start) {
        case 1:
          {
            text = `0${change.proposed.text}/`;
            break;
          }
        case 4:
          {
            text = `${change.proposed.text.slice(0, 3)}0${change.proposed.text[3]}
                 /`;
            break;
          }
        default:
          return false;
      }
      change.proposed = {
        text,
        selectedRange: {
          start: text.length,
          length: 0
        }
      };
      return super.isChangeValid(change, error);
    }
    if (/^\d*$/.test(change.inserted.text)) {
      if (change.inserted.start === 0 && Number.parseInt(change.proposed.text, 10) > 1) {
        const text = `0${change.proposed.text}/`;
        change.proposed = {
          text,
          selectedRange: {
            start: text.length,
            length: 0
          }
        };
      }
      if (change.inserted.start === 3 && Number.parseInt(change.inserted.text, 10) > 3) {
        const text = `${change.proposed.text.slice(0, 2)}0${change.inserted.text}/`;
        change.proposed = {
          text,
          selectedRange: {
            start: text.length,
            length: 0
          }
        };
      }
      return super.isChangeValid(change, error);
    } else {
      return false;
    }
  }
  format(value) {
    return USDateFormatter.format(value);
  }
  parse(str) {
    return USDateFormatter.parse(str);
  }
  static format(value) {
    return USDate.format(value);
  }
  static parse(str) {
    return USDate.parse(str);
  }
}